<template>
  <div id="login-view">
    <form
      @submit.prevent="submit"
      class="md-layout md-alignment-center-center">
      <md-card class="md-layout-item md-size-50 md-small-size-100 md-elevation-5">
        <md-card-header>
          <div class="md-title">S'identifier</div>
        </md-card-header>
        <md-card-content>
          <md-field
            :class="{ 'md-invalid': $v.inputs.username.$error || loginHasError }">
            <label for="username">Nom d'utilisateur</label>
            <md-input
              name="username"
              id="username"
              v-model="inputs.username"
              @keyup="resetFormErrors()"
              required />
            <span
              class="md-error"
              v-if="$v.inputs.username.required && loginHasError">
              {{ loginErrorMessage }}
            </span>
            <span
              class="md-error"
              v-if="!$v.inputs.username.required">
              Ce champ est obligatoire
            </span>
          </md-field>
          <md-field
            :class="{ 'md-invalid': $v.inputs.password.$error || passwordHasError }">
            <label for="password">Mot de passe</label>
            <md-input
              name="password"
              id="password"
              type="password"
              @keyup.enter="cleanLoginForm()"
              v-model="inputs.password"
              required />
            <span class="md-error">{{ passwordErrorMessage }}</span>
            <span
              class="md-error"
              v-if="!$v.inputs.password.required">Ce champ est obligatoire</span>
          </md-field>
        </md-card-content>
        <div class="actions">
          <div>
            <router-link to="/password_reset">réinitialiser le mot de passe</router-link>
          </div>
          <md-button
            @click="cleanLoginForm()"
            class="md-primary md-raised"
            id="login-button">Connexion</md-button>
        </div>
      </md-card>
    </form>
    <div class="partners text-center">
      <h2>Projet soutenu par…</h2>
      <ul class="partners_list">
        <li>
          <a
            href="https://www.ademe.fr/"
            target="_blank"
            rel="no-follow"
          >
            <img
              src="../assets/img/ademe-logo.png"
              alt="Ademe"
            >
          </a>
        </li>
        <li>
          <a
            href="https://www.auvergnerhonealpes.fr/"
            target="_blank"
            rel="no-follow"
          >
            <img
              src="../assets/img/europe-logo.png"
              alt="Europe"
            >
          </a>
        </li>
        <li>
          <a
            href="https://www.auvergnerhonealpes.fr/"
            target="_blank"
            rel="no-follow"
          >
            <img
              src="../assets/img/rl-logo.png"
              alt="Région Auvergne Rhône alpes"
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  validations () {
    var validations = {
      inputs: {
        username: {
          required
        },
        password: {
          required
        }
      }
    }
    return validations
  },
  data () {
    return {
      inputs: {
        username: '',
        password: ''
      },
      loginHasError: false,
      passwordHasError: false,
      loginErrorMessage: null,
      passwordErrorMessage: null
    }
  },
  created () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Se connecter')
    app.$store.dispatch('routing/update_return_kwargs', null)
  },
  methods: {
    resetFormErrors () {
      var app = this
      app.loginHasError = false
      app.passwordHasError = false
      app.loginErrorMessage = null
      app.passwordErrorMessage = null
    },
    cleanLoginForm () {
      var app = this

      app.resetFormErrors()
      app.$v.inputs.$touch()

      if (!app.$v.inputs.$invalid) {
        app.login(app.inputs)
      }
    },
    login ({ username, password }) {
      var app = this

      app.$store.dispatch('auth/login', { username, password })
        .catch(function (error) {
          var response = error.response
          if (response.status === 400) {
            if ('password' in response.data) {
              app.passwordHasError = true
              app.passwordErrorMessage = response.data['password'][0]
            }

            if ('non_field_errors' in response.data) {
              app.loginHasError = true
              app.loginErrorMessage = response.data['non_field_errors'][0]
            }
          }
        })
        .then(() => app.$store.dispatch('auth/getAccountDetails'))
        .then(() => app.$router.push('/'))
    }
  }
}
</script>

<style scoped lang="scss">
form {
  padding-top: 5vh;
  .md-card-header {
    border-bottom: 1px solid #eee;
    margin-top: 2px;
  }
  .md-card-content {
    padding-top: 20px;
  }
  .md-primary {
    color: white !important;
  }
  .actions {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eee;
    background: #f5f5f5;
  }
}
.partners{
  margin-top: 30px;
}
.text-center{
  text-align:center;
}
.partners_list{
  margin-top: 2rem;
  display: flex;
  list-style: none;
  padding-left: 0;
  justify-content: center;
  align-items: center;
  li{
    margin: 10px;
    &:nth-child(1){
      img{
        max-width: 180px;
      }
    }
    &:nth-child(2){
      img{
        max-width: 100px;
      }
    }
    &:nth-child(3){
      img{
        max-width: 160px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue